import * as actionTypes from "../actions/actionTypes";

const initialState = {
  valid: false,
  amount: 0,
  expiryDate: '',
  discountOperation: '',
  code: null
};

const linkVoucherReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LINK_VOUCHER_LOAD:
      return {
        ...state,
        valid: action.payload.active,
        amount: action.payload.value,
        expiryDate: action.payload.expiryDate,
        discountOperation: action.payload.discountOperation
      };
    default:
      return state;
  }
};

export default linkVoucherReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/linkVoucherReducer.js